// Import model
import { RoomSelectionCondition } from '../models/RoomSelectionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { RoomSelectionIndexedFields } from '../models/RoomSelectionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { RoomSelectionIndexedFieldsSerializer } from './RoomSelectionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for RoomSelectionCondition - handles JSON serialization and deserialization with type validation
 */
export class RoomSelectionConditionSerializer {
  /**
   * Deserializes a JSON string into a RoomSelectionCondition instance
   */
  static deserialize(json: string): RoomSelectionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a RoomSelectionCondition instance
   */
  static fromObject(obj: any): RoomSelectionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to RoomSelectionCondition');
    }


    const instance: RoomSelectionCondition = {
      fieldName: obj['fieldName'] as RoomSelectionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of RoomSelectionCondition instances
   */
  static deserializeArray(json: string): RoomSelectionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a RoomSelectionCondition instance to a JSON string
   */
  static serialize(instance: RoomSelectionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a RoomSelectionCondition instance to a plain object
   */
  static toObject(instance: RoomSelectionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of RoomSelectionCondition instances to a JSON string
   */
  static serializeArray(instances: RoomSelectionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
